import { createStore } from "vuex";

import general from "./modules/general";
import creationModule from "./modules/patient-creation";
import assessmentModule from "./modules/patient-assessment";
import homeOverview from "./modules/home-overview";
import headerStore from "./modules/header";
import sidebarStore from "./modules/sidebar";
import overviewPage from "./modules/overview-page";

const store = new createStore({
  modules: {
    general,
    creation: creationModule,
    assessment: assessmentModule,
    homeOverview: homeOverview,
    header: headerStore,
    sidebar: sidebarStore,
    overviewPage: overviewPage,
  },
});

export default store;
